//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VyInput from './VyInput'
import mixinComponent from './mixinComponent.js'

export default {
  name: 'VyInputText',
  components: {
    VyInput,
  },
  mixins: [mixinComponent],
  props: {
    title: {type: String, default: ''}, // 标题
    placeholder: {type: String, default: '请输入'}, // 占位提示文字
    required: {type: Boolean, default: false}, // 必填
    readonly: {type: Boolean, default: false}, // 只读
    disabled: {type: Boolean, default: false}, // 禁用
    hide: {type: Boolean, default: false}, // 隐藏
  },
  computed: {
    currentValue: {
      get () { return this.value },
      set (newValue) { this.$emit('input', newValue) },
    },
  },
  methods: {
    onFocus (newValue, event) {
      this.$emit('on-focus', this.fieldKey, newValue, event)
    },
    onBlur (newValue, event) {
      this.$emit('on-blur', this.fieldKey, newValue, event)
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/basic/VyInputText.vue